var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankPayments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#363853"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_4244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.833 43.3335H46.1663V46.1668H17.833V43.3335ZM20.6663 32.0002H23.4997V41.9168H20.6663V32.0002ZM27.7497 32.0002H30.583V41.9168H27.7497V32.0002ZM33.4163 32.0002H36.2497V41.9168H33.4163V32.0002ZM40.4997 32.0002H43.333V41.9168H40.4997V32.0002ZM17.833 24.9168L31.9997 17.8335L46.1663 24.9168V30.5835H17.833V24.9168ZM20.6663 26.6678V27.7502H43.333V26.6678L31.9997 21.0012L20.6663 26.6678ZM31.9997 26.3335C31.624 26.3335 31.2636 26.1842 30.9979 25.9186C30.7323 25.6529 30.583 25.2926 30.583 24.9168C30.583 24.5411 30.7323 24.1808 30.9979 23.9151C31.2636 23.6494 31.624 23.5002 31.9997 23.5002C32.3754 23.5002 32.7357 23.6494 33.0014 23.9151C33.2671 24.1808 33.4163 24.5411 33.4163 24.9168C33.4163 25.2926 33.2671 25.6529 33.0014 25.9186C32.7357 26.1842 32.3754 26.3335 31.9997 26.3335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_4244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankPayments);
export default __webpack_public_path__ + "static/media/BankPayments.c9c68538fab638d135aad537f2b31b51.svg";
export { ForwardRef as ReactComponent };